import React from 'react';
import { FormattedMessage } from 'react-intl';

import { formatDuration } from '../Utils';
import SquareChip from '../SquareChip';

interface DurationSquareChipProps {
	id: string;
	defaultMessage: string;
	duration: {
		days?: number;
		hours?: number;
		minutes?: number;
	};
}

export default function DurationSquareChip(props: DurationSquareChipProps) {
	return (
		<SquareChip
			label={
				<FormattedMessage
					id={props.id}
					defaultMessage={props.defaultMessage}
					values={{ duration: formatDuration(props.duration) }}
				/>
			}
		/>
	);
}
